export const SHOW_REPORT_MODAL = 'SHOW_REPORT_MODAL';
export const HIDE_REPORT_MODAL = 'close_report_modal';
export const GET_DISTRIBUTORS_REPORTS = 'get_distributors_reports';
export const GET_SUPPLIER_REPORTS = 'get_supplier_reports';
export const UPDATE_DISTRIBUTOR_REPORT = 'update_distributor_report';
export const GET_CASHBACK_REPORTS = 'get_cashback_reports';
export const GET_PROBLEMATIC_ORDERS = 'get_problematic_orders';
export const REGENERATE_REPORTS = 'regenerate_reports';